// extracted by mini-css-extract-plugin
module.exports = {"container":"TableOfferActions_container__1duNP","link":"TableOfferActions_link__2WOIl"};